<template>
  <v-card class="ebf-page-header mb-5" elevation="1">
    <v-card-text class="d-flex flex-wrap align-center ga-4 pa-5">
      <v-avatar color="white" variant="tonal" size="52">
        <v-icon size="30">{{ icon }}</v-icon>
      </v-avatar>
      <div class="flex-grow-1">
        <div class="text-h5 font-weight-bold">{{ title }}</div>
        <div v-if="subtitle" class="text-body-2 mt-1 opacity-80">{{ subtitle }}</div>
      </div>
      <div class="ebf-no-print d-flex flex-wrap ga-2">
        <slot />
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup>
defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, default: "" },
  icon: { type: String, default: "mdi-account-cash-outline" },
});
</script>
